import React, { useContext } from "react";
import { css } from "emotion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors, textSizes, boxStyles } from "../../styles/theme";
import TitleBlock from "../TitleBlock";
import { BuildContext } from "../../context/BuildSpotlightState";
import { withRouter } from "react-router-dom";
import headerInfo from "./data/headerInfo";
import BuildPreview from "./BuildPreview";

const BuildHeaderMobile = ({ history }) => {
  const { stage, setStage, type } = useContext(BuildContext);

  const handleBack = () => {
    if (stage === 0) {
      history.push("/home");
    } else if (type === "text" && stage === 3) {
      setStage(stage - 2);
    } else {
      setStage(stage - 1);
    }
  };

  return (
    <div className={container}>
      <div className="back-btn" onClick={handleBack}>
        <FontAwesomeIcon className="icon" icon="chevron-left" />
        <p>BACK</p>
      </div>

      {stage === 0 && <TitleBlock
        title={headerInfo[stage].title}
        subtitle={headerInfo[stage].subtitle}
        style="title-block"
      />}
      {stage > 0 && <BuildPreview />}
    </div>
  );
};

export default withRouter(BuildHeaderMobile);

const container = css`
  .back-btn {
    padding: ${boxStyles.standardPadding};
    display: flex;
    align-items: center;
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
    cursor: pointer;
    p {
      padding-left: 5px;
    }
  }

  .title-block {
    min-height: 140px;
    margin: 0;
  }
`;
